import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import withTranslation from '../../../hoc/withTranslation';
import styles from '../../../styles/styles';
import ControlledEditor from '../../form/ControlledEditor/ControlledEditor';
import { renderNumberField, renderSelectField, renderTextField } from '../../../services/form';
import i18n from 'i18next';
import { RICHTEXT } from '../../../constants/customfiled';
import MenuItem from 'material-ui/MenuItem';

const validate = values => {
    const errors = {};
    [
        'name',
        'description',
        'required_points'
    ].forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    if(
        values['required_points'] !== undefined
        && values['required_points'] !== null
        && values['required_points'] <= 0
    ) {
        errors['required_points'] = i18n.t('module.gamification.required_points_min_zero');
    }
    return errors;
};

const parseIntOrReturnZero = (val) => {
    if (val !== undefined && val !== null) {
        if (typeof val === 'string' && val === '') {
            return 0;
        }
        return parseInt(val, 10);
    }
    return 0;
}

export class AchievementForm extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        achievement: PropTypes.object,
        onFormReset: PropTypes.func,
        handleSubmit: PropTypes.func,
        pristine: PropTypes.any,
        submitting: PropTypes.bool,
        t: PropTypes.func,
        customFields: PropTypes.arrayOf(PropTypes.object),
        defaultAcquisitionType: PropTypes.string,
    };

    static defaultProps = {
        customFields: [],
    };

    onResetForm = () => {
        this.props.reset();
        if (this.props.onFormReset) {
            this.props.onFormReset();
        }
    };

    render() {
        const {
            handleSubmit,
            pristine,
            submitting,
            t
        } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="acquisition_type"
                        name="acquisition_type"
                        component={renderSelectField}
                        fullWidth={true}
                        initialValue={this.props.defaultAcquisitionType}
                        label={this.props.t('module.gamification.acquisition_type')}
                    >
                        {['point', 'quiz', 'client'].map(type => (
                            <MenuItem
                                key={type}
                                value={type}
                                primaryText={this.props.t('module.gamification.acquisition_types.' + type)}
                            />
                        ))}
                    </Field>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={t('generic.name')}
                        fullWidth={true}
                    />
                    <Field
                        id="description"
                        name="description"
                        component={ControlledEditor}
                        initialValue={this.props.initialValues ? this.props.initialValues.description : ""}
                        label={this.props.t("generic.description")}
                        fullWidth={true}
                    />
                    <Field
                        type="number"
                        id="required_points"
                        name="required_points"
                        component={renderNumberField}
                        label={t("module.gamification.required_points")}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseIntOrReturnZero(val)}
                    />
                    {this.props.customFields && this.props.customFields.map((cf) => {
                        let name = cf.name;

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')';
                        }
                        if (cf.type === RICHTEXT) {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={ControlledEditor}
                                    initialValue={this.props.initialValues
                                        ? this.props.initialValues.other_translations[cf.id]
                                        : ''}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        } else {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={renderTextField}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        }
                    })}
                </div>

                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    {this.props.initialValues === undefined &&
                        <RaisedButton
                            style={styles.formButton}
                            label="Save and Create New"
                            disabled={pristine || submitting}
                            type="button"
                            primary={true}
                            onClick={() => {
                                // In case of success, handle submit returns undefined, otherwise it returns the list of errors
                                if (handleSubmit() === undefined) {
                                    this.onResetForm();
                                }
                            }}
                        />
                    }
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={this.onResetForm}
                    />
                </div>
            </form>
        );
    }

}

export default reduxForm({
    form: 'editAchievement',
    validate,
})(withTranslation(AchievementForm));



// WEBPACK FOOTER //
// src/components/achievement/AchievementForm/AchievementForm.js